export default "__VITE_ASSET__CE_cXE2s__"